module.exports = __webpack_public_path__ + "/templates/components/forms/form-base.twig";